import dynamic from 'next/dynamic';
import { useSelector } from 'react-redux';

import {
  isFrancePlatform,
  isItalyPlatform,
  isSpainPlatform,
} from '@/domains/core/settings/utils';
import { RECOMMENDATION_ENGINES } from '@/domains/productDiscovery/Recommendation/constants';
import { useRecommendationSelector } from '@/domains/productDiscovery/Recommendation/hooks/useRecommendationSelector/useRecommendationSelector';
import type { MFAlternativeProps } from '@/productDiscovery/ProductPage/b2c/modules/MFAlternative/MFAlternative';
import { useDetail } from '@/productDiscovery/ProductPage/hooks/useDetail';

const DynamicMFAlternative = dynamic<MFAlternativeProps>(
  () => import('./MFAlternative').then((mod) => mod.MFAlternative),
  { ssr: false, loading: () => <div className="h-[93px]" /> },
);

export const MFAlternativeContainer = () => {
  const { delivery } = useDetail();

  const { recommendationConfigSelector } = useRecommendationSelector(
    RECOMMENDATION_ENGINES.SIMILARITY_ML_V2,
  );

  const similarityConfig = useSelector(recommendationConfigSelector);

  const shouldRenderMFAlternative =
    isSpainPlatform() || isItalyPlatform() || isFrancePlatform();

  if (delivery?.fulfillment || !similarityConfig || !shouldRenderMFAlternative)
    return null;

  return <DynamicMFAlternative modelIds={similarityConfig?.modelIds || []} />;
};

MFAlternativeContainer.displayName = 'MFAlternativeContainer';
